/* eslint-disable react/jsx-key */
import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

// Route components — all lazy-loaded so each screen ships as its own
// chunk and the initial page (SignIn) downloads as little JS as possible.
const SignIn = lazy(() => import('../pages/SignIn'))
const Home = lazy(() => import('../pages/Home'))
const Menu = lazy(() => import('../pages/Menu'))
const MenuCustomize = lazy(() => import('../pages/MenuCustomize'))
const Order = lazy(() => import('../pages/Order'))
const Receipt = lazy(() => import('../pages/Receipt'))
const Reservation = lazy(() => import('../pages/ReservationBoard'))
// Design-system showcase — mirrors /_dev/components in the merchant app.
// Unauthenticated by design so the route is reachable on a fresh dev install.
const ComponentsPreview = lazy(() => import('../design-system/_preview/ComponentsPreview'))

const routes = [
  <Route path="/signin/:outletId/:tableNo" exact component={SignIn} />,
  <Route path="/home/:outletId/:tableNo" exact component={Home} />,
  <Route path="/menu" exact component={Menu} />,
  <Route path="/menuCustomize" exact component={MenuCustomize} />,
  <Route path="/receipt" exact component={Receipt} />,
  <Route path="/order" exact component={Order} />,
  <Route path="/reservation/merchant/:merchantId" exact component={Reservation} />,
  <Route path="/_dev/components" exact component={ComponentsPreview} />,
]

export default routes
